import {Col, Row} from "../../components/Flex/Flex.tsx";
import {Paper, Select, NumberInput, Switch} from "@mantine/core";
import {useEntityTypes} from "../../utils/api.ts";
import {useCallback, useMemo, useState} from "react";
import Label from "../../components/Label/Label.tsx";
import {Duration} from "luxon";


export default function ShipSpeed() {
    const [selectedShip, setSelectedShip] = useState<string | null>(null);
    const [hyperSpeed, setHyperSpeed] = useState<number | null>(null);
    const [sublightSpeed, setSublightSpeed] = useState<number | null>(null);
    const [isShowdown, setIsShowdown] = useState<boolean>(false);
    const {ships} = useEntityTypes(['ships'], true);

    const [skill, setSkill] = useState<number|null>(0);

    const [distanceHyper, setDistanceHyper] = useState<number|null>(1);
    const [distanceSublight, setDistanceSublight] = useState<number|null>(1);


    const timeHyper = useMemo(() => {
        let seconds = 0;
        if(skill !== null && hyperSpeed !== null && distanceHyper !== null && hyperSpeed > 0) {
            seconds = Math.floor((7200 / hyperSpeed)/(1+(skill*0.05))) * distanceHyper;
        }

        return Duration.fromObject({seconds}).rescale();
    }, [hyperSpeed, skill, distanceHyper]);

    const timeSublight = useMemo(() => {
        let seconds = 0;
        if(skill !== null && sublightSpeed !== null && distanceSublight !== null && sublightSpeed > 0) {
            seconds = (Math.floor((36000) * (1/(sublightSpeed * (1 + skill*0.05)))));

            if(isShowdown) {
                seconds = Math.round(seconds /10);
            }
            seconds = seconds * distanceSublight;
        }
        return Duration.fromObject({seconds}).rescale();
    }, [sublightSpeed, skill, distanceSublight, isShowdown]);

    const onShipSelection = useCallback((value: string | null) => {
        setSelectedShip(value);
        const ship = ships.find(s => s.id === value);
        if(ship) {
            setHyperSpeed(ship.speed.hyper);
            setSublightSpeed(ship.speed.sublight);
        }
    }, [ships]);

    return (
        <div className="w-full">
            <title>Ship Speed Calculator</title>
            <Row align="center">
                <Col><h1>Ship Speeds</h1></Col>
                <Col grow={1} />
                {/*<Col><a className="link no-underline" href="https://www.swcombine.com/rules/?Movement" target="_blank"><Icon icon={IconMap.SwcRules} /> Full rules</a></Col>*/}
            </Row>
            <Row mb={3}>
                <Col>
                    <Label htmlFor="ship" className="mb-2">Ship</Label>
                    <Select value={selectedShip} data={ships.map(i => ({value: i.id, label: i.name}))} onChange={onShipSelection} placeholder="Select a ship" searchable/>
                </Col>
                <Col>
                    <Label htmlFor="skill" className="mb-2">Skill</Label>
                    <NumberInput value={skill} onChange={setSkill} min={0} max={5} style={{width: 80}}/>
                </Col>
                <Col>
                    <Label htmlFor="isShowdown" className="mb-2">Showdown Reduction</Label>
                    <Switch checked={isShowdown} onChange={e => setIsShowdown(e.currentTarget.checked)}/>
                </Col>
            </Row>



            <Paper className="mb-3">
                <h3 className="mt-0">Hyperspeed</h3>
                <Row mb={4}>
                    <Col>
                        <Label htmlFor="hyperSpeed" className="mb-2">HyperSpeed</Label>
                        <NumberInput id="hyperSpeed" value={hyperSpeed} onChange={setHyperSpeed} min={0} max={15} style={{width: 80}}/>
                    </Col>
                    <Col>
                        <Label htmlFor="distanceHyper" className="mb-2">Distance</Label>
                        <NumberInput id="distanceHyper" value={distanceHyper} onChange={setDistanceHyper} min={1} style={{width: 80}}/>
                    </Col>
                </Row>
                <b>Time: {timeHyper.toHuman()}</b>
            </Paper>
            <Paper className="mb-3">
                <h3 className="mt-0">Sublight</h3>
                <Row mb={4}>
                    <Col>
                        <Label htmlFor="sublightSpeed" className="mb-2">Sublight Speed</Label>
                        <NumberInput id="sublightSpeed" value={sublightSpeed} onChange={setSublightSpeed} min={0} max={150} step={5} style={{width: 80}}/>
                    </Col>
                    <Col>
                        <Label htmlFor="sublightDistance" className="mb-2">Distance</Label>
                        <NumberInput id="sublightDistance" value={distanceSublight} onChange={setDistanceSublight} min={1} max={22} style={{width: 80}}/>
                    </Col>
                </Row>
                <b>Time: {timeSublight.toHuman()}</b>
            </Paper>
        </div>
    )
}
